import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3426a800"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wall-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "before" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "item-cont" }
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "detail" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "desc" }
const _hoisted_12 = { class: "before" }
const _hoisted_13 = {
  key: 1,
  class: "empty"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-onetabsousuoshibai" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "暂无数据", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]

import { ref, onMounted, reactive, watch } from 'vue';
import { RaDivider, RaMessage, RaInput } from '@rafter/pc';
import { addBookmark, getIcons } from '@/api/baseApi';
import { bookmarks } from '@/store/bookmarks';
import { RaIcon } from '@rafter/icon';

export default /*#__PURE__*/_defineComponent({
  __name: 'CommonComp',
  props: {
  categorie: {
    type: Object,
    default: () => {},
  },
  searchKey: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: '',
  },
  sortId: {
    type: Number,
    default: 0,
  },
},
  emits: ['getMarks'],
  setup(__props, { emit: emits }) {

const props = __props;



const loading = ref(false);
const tab = ref({
  label: '热门',
  value: 'hot',
});
const checked = ref<{
  type?: number;
  name?: string;
  url?: string;
  category_uuid?: string;
  icon?: string;
  order?: number;
  color?: string;
  describe?: string;
}>({});
onMounted(() => {
  handleSort();
});
const listRef = ref();
const contRef = ref();
const wallPaperKinds = [
  {
    label: '热门',
    value: 'hot',
  },
  {
    label: '新闻',
    value: 'news',
  },
  {
    label: '音乐',
    value: 'music',
  },
  {
    label: '图片',
    value: 'photos',
  },
  {
    label: '购物',
    value: 'shopping',
  },
  {
    label: '社交',
    value: 'social',
  },
  {
    label: '运动',
    value: 'sports',
  },
  {
    label: '生活',
    value: 'life',
  },
  {
    label: '游戏',
    value: 'games',
  },
  {
    label: '教育',
    value: 'education',
  },
  {
    label: '科技',
    value: 'tech',
  },
  {
    label: '金融',
    value: 'finance',
  },
  {
    label: '阅读',
    value: 'read',
  },
  {
    label: '其他',
    value: 'others',
  },
];
const defaultCommonMarks = ref([]);
const handleComp = (item) => {
  checked.value = item;
  window['_paq'].push(['trackEvent', '书签', '常用新增', checked.value.url, 1]);
  addBookmark({
    type: props.type ? 3 : 1,
    name: checked.value.name,
    url: checked.value.url,
    category_uuid: bookmarks.getActive()?.uuid,
    icon: checked.value.icon,
    order: bookmarks.getActive()?.bookmarks.length + 1,
    color: checked.value.color,
    describe: checked.value.describe ?? '',
  })
    .then((res) => {
      RaMessage({
        type: 'success',
        message: '添加成功',
      });

      bookmarks.addOneToActive(res);
    })
    .catch((err) => {
      RaMessage({
        type: 'error',
        message: '接口出错',
      });
    });
};
const page = ref(1);
const handleSort = (more = '') => {
  if (!more) {
    defaultCommonMarks.value = [];
    page.value = 1;
  }
  loading.value = true;
  let params = {
    type_id: props.sortId,
    page: page.value, // 请求分页
    size: 28, // 分页大小
  };
  getIcons(params)
    .then((res) => {
      if (res.data.code === 200) {
        defaultCommonMarks.value = [
          ...defaultCommonMarks.value,
          ...res.data.data?.data?.map((item) => ({
            ...item,
            icon: item.logo,
            type: props.type ? 3 : 1,
          })),
        ];
        loading.value = false;
      }
    })
    .catch((err) => {
      RaMessage({
        type: 'error',
        message: '接口出错',
      });
      loading.value = false;
    });
};
const handleScroll = (event) => {
  const totalHeight = contRef.value?.offsetHeight;
  const scrollHeight = listRef.value.scrollTop + listRef.value?.offsetHeight;
  if (totalHeight <= scrollHeight) {
    page.value += 1;
    handleSort('below');
  }
};
watch(
  () => props.sortId,
  () => {
    handleSort();
  }
);

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "listRef",
      ref: listRef,
      class: "list",
      onScroll: handleScroll
    }, [
      (defaultCommonMarks.value.length || props.type)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref_key: "contRef",
            ref: contRef,
            class: _normalizeClass({ 'list-cont': true, 'comp-cont': !!props.type })
          }, [
            (!props.type)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(defaultCommonMarks.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass({ item: true, active: item.id === checked.value.id }),
                    key: item.id,
                    onClick: ($event: any) => (handleComp(item)),
                    style: _normalizeStyle({ backgroundImage: `url(${item.icon})` })
                  }, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(item.name), 1),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(RaIcon), { icon: "Plus" })
                    ])
                  ], 14, _hoisted_2))
                }), 128))
              : _createCommentVNode("", true),
            (props.type)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(defaultCommonMarks.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass({ 'comp-item': true, active: item.id === checked.value.id }),
                    key: item.id,
                    onClick: ($event: any) => (handleComp(item))
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("img", {
                          src: item.icon,
                          alt: ""
                        }, null, 8, _hoisted_8)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(item.name), 1),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(item.describe || item.name), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_unref(RaIcon), { icon: "Plus" })
                    ])
                  ], 10, _hoisted_5))
                }), 128))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      (!defaultCommonMarks.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
        : _createCommentVNode("", true)
    ], 544)
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})